import { forwardRef, type ReactNode } from 'react';
import { Button } from 'antd';
import type { ButtonProps } from 'antd';

export type IpcButtonVariant = 'primary' | 'secondary' | 'destructive' | 'ghost' | 'link';
export type IpcButtonSize = 'small' | 'middle' | 'large';

type Props = Omit<ButtonProps, 'type' | 'danger' | 'size' | 'variant'> & {
  variant?: IpcButtonVariant;
  size?: IpcButtonSize;
  iconOnly?: boolean;
  children?: ReactNode;
};

function mapAntdType(variant: IpcButtonVariant): ButtonProps['type'] {
  if (variant === 'primary') return 'primary';
  if (variant === 'link') return 'link';
  if (variant === 'ghost') return 'text';
  return 'default';
}

/** Showcase §1 + UI-STANDARDS：Primary / Secondary / Destructive / Ghost / Link */
export const IpcButton = forwardRef<HTMLButtonElement | HTMLAnchorElement, Props>(
  function IpcButton(
    {
      variant = 'secondary',
      size = 'middle',
      iconOnly = false,
      className,
      children,
      ...rest
    },
    ref,
  ) {
    const classes = [
      'ipc-btn',
      `ipc-btn--${variant}`,
      iconOnly ? 'ipc-btn--icon-only' : '',
      className,
    ]
      .filter(Boolean)
      .join(' ');

    return (
      <Button
        {...rest}
        ref={ref}
        type={mapAntdType(variant)}
        danger={variant === 'destructive'}
        size={size}
        className={classes}
      >
        {children}
      </Button>
    );
  },
);
